<template>
  <div id="app">

    <div v-wechat-title="$route.meta.title"></div>
    <!-- 路由匹配到的组件将显示在这里 -->
    <router-view> </router-view>

    <!-- 底部tabbar 组件 -->
    <AppTabBar v-if="$route.meta.isshowtabbar"></AppTabBar>
  </div>
</template>

<script>
import AppTabBar from './components/AppTabBar.vue'

export default {
  name: 'App',
  components: {
    AppTabBar
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body {
  width: 100%;
  height: 100%;
}
</style>
